import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery } from 'gatsby'
import { graphql } from 'gatsby'

import GreenPathCSS from './section-greenpath.module.css'

const FingerGreenPath = ({ fullpageApi }) => (
  <StaticQuery
    query={graphql`
      query ImageOneGreenPath {
        file(
          relativePath: {
            eq: "projets/Labo/finger/photos/finger-greenpath.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1000, quality: 87) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={({ file }) => (
      <div
        className="section"
        onClick={() => fullpageApi.moveSectionDown()}
        onKeyDown={() => fullpageApi.moveSectionDown()}
        role="button"
        tabIndex={0}
        style={{ cursor: 'pointer' }}
      >
        <Img
          className={GreenPathCSS.image}
          fluid={file.childImageSharp.fluid}
        />
      </div>
    )}
  />
)

export default FingerGreenPath
